import { cn } from "@theprelude/core";

export const ShieldFlash: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 12 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0.522 1.88396L6 0.666626L11.478 1.88396C11.626 1.91687 11.7584 1.99927 11.8533 2.11756C11.9482 2.23586 12 2.38297 12 2.53463V9.19263C12 9.85112 11.8373 10.4994 11.5266 11.08C11.2158 11.6605 10.7666 12.1554 10.2187 12.5206L6 15.3333L1.78133 12.5206C1.23352 12.1554 0.784307 11.6607 0.473565 11.0803C0.162824 10.4998 0.000157571 9.85167 0 9.19329V2.53463C2.60252e-05 2.38297 0.0517586 2.23586 0.14666 2.11756C0.241561 1.99927 0.373958 1.91687 0.522 1.88396ZM1.33333 3.06929V9.19263C1.33334 9.6316 1.44172 10.0638 1.64884 10.4508C1.85597 10.8379 2.15543 11.1678 2.52067 11.4113L6 13.7313L9.47933 11.4113C9.84447 11.1678 10.1439 10.838 10.351 10.4511C10.5581 10.0642 10.6665 9.63215 10.6667 9.19329V3.06929L6 2.03329L1.33333 3.06929ZM6.66667 6.66663H8.66667L5.33333 11.3333V7.99996H3.33333L6.66667 3.33329V6.66663Z" />
  </svg>
);
